var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.percent)?_c('div',{staticClass:"download-progress"},[_c('el-progress',{attrs:{"percentage":_vm.mapPercent}}),_c('el-button',{attrs:{"type":"danger","plain":""},on:{"click":_vm.cancelDownload}},[_vm._v("取消")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }